import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { BusinessAccountProfile } = protos;

export function fetchBusinessProfile(): ApiAction {
  return {
    TockApi: {
      getProto: '/business/profile',
      type: AppConstants.BUSINESS_PROFILE_FETCH,
    },
  };
}

export function upsertBusinessProfile(profile: core.BusinessAccountProfile): ApiAction {
  const request = BusinessAccountProfile.fromObject(profile);
  return {
    TockApi: {
      request,
      postProto: '/business/profile',
      type: AppConstants.BUSINESS_PROFILE_FETCH,
      toast: 'Profile updated successfully',
    },
  };
}
